<template>
  <div @keyup.esc="reset">
    <slot
      :drawerOpen="drawerOpen"
      :reduceMotion="reduceMotion"
      :afterDrawerOpen="afterDrawerOpen"
      :beforeDrawerClose="beforeDrawerClose"
    >
    </slot>
    <transition name="exhibition-masthead__overlay-">
      <div
        class="exhibition-masthead__overlay"
        v-show="drawerOpen"
        @click="reset"
      ></div>
    </transition>
  </div>
</template>

<script lang="js">
import { mapState } from 'vuex';
import supportsIntersectionObserver from '../../js/util/supportsIntersectionObserver';

export default {
  name: 'ahc-exhibition-masthead',
  computed: {
    ...mapState(['topAlertActive', 'drawerOpen', 'reduceMotion']),
    isAdmin() {
      return (document.body.classList.contains('admin-bar'));
    }
  },
  watch: {
    topAlertActive() {
      this.$nextTick(() => {
        this.adjustNavPosition();
      });
    },
  },
  methods: {
    reset() {
      this.$store.commit('setDrawerOpen', false);
    },
    adjustNavPosition() {
      const alertHeight = this.topAlertActive ? document.querySelector('.alert--top').offsetHeight : 0;
      const adminBarHeight = this.isAdmin ? document.querySelector('#wpadminbar').offsetHeight : 0;

      if (this.topAlertActive) {
        this.$el.parentNode.style.top = `${alertHeight + adminBarHeight}px`;
      } else {
        this.$el.parentNode.style.top = '';
      }
    },
    handleResize() {
      this.adjustNavPosition();
    },
    afterDrawerOpen() {
      const drawerMenu = this.$el.querySelector('.exhibition-masthead__drawer');

      if (supportsIntersectionObserver) {
        this.exitMenuObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.intersectionRatio <= 0.25 && this.drawerOpen) {
              observer.unobserve(drawerMenu);
              this.reset();
            }
          });
        }, { threshold: 0.25 });

        this.exitMenuObserver.observe(drawerMenu);
      }
    },
    beforeDrawerClose() {
      const drawerMenu = this.$el.querySelector('.exhibition-masthead__drawer');

      if (drawerMenu && this.exitMenuObserver) {
        this.exitMenuObserver.unobserve(drawerMenu);
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    this.beforeDrawerClose();
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>
